import g1 from '@/archive/app/Qiaodong/BPF/workshop/bpf/Group_1/poets_group_1.json';
import g2 from '@/archive/app/Qiaodong/BPF/workshop/bpf/Group_2/poets_group_2.json';
import g3 from '@/archive/app/Qiaodong/BPF/workshop/bpf/Group_3/poets_group_3.json';
import g4 from '@/archive/app/Qiaodong/BPF/workshop/bpf/Group_4/poets_group_4.json';
import g5 from '@/archive/app/Qiaodong/BPF/workshop/bpf/Group_5/poets_group_5.json';

/** 各组 JSON 诗人键不同，不能用单一 typeof；统一为联合类型供路由页安全索引 */
export type WorkshopGroupBundle = typeof g1 | typeof g2 | typeof g3 | typeof g4 | typeof g5;

export const workshopByGroupId: Record<string, WorkshopGroupBundle> = {
  Group_1: g1,
  Group_2: g2,
  Group_3: g3,
  Group_4: g4,
  Group_5: g5,
};
